import Pagination from '@/types/Pagination.interface'
import Person, { Email, Phone } from '@/types/Person.interface'

interface State {
    personsDuplicates: Person[] | Email[] | Phone[]
    personsDuplicatesLastPage: number
    personsDuplicatesNextPage: number
    personsDuplicatesFilter: string
    personsDuplicatesParams: object
    personsDuplicatesPaginating: boolean
    personsDuplicatesFind: Person[] | Email[] | Phone[]
}

const defaults = () => {
    return {
        personsDuplicates: [],
        personsDuplicatesLastPage: null,
        personsDuplicatesNextPage: null,
        personsDuplicatesFilter: 'phone',
        personsDuplicatesParams: null,
        personsDuplicatesPaginating: false,
        personsDuplicatesFind: null,
    }
}

export default {
    state: defaults(),
    mutations: {
        personsDuplicatesSet (state: State, fields: Person[] | Email[] | Phone[]) {
            state.personsDuplicates = fields
        },
        personsDuplicatesFilterSet (state: State, string: string): void {
            state.personsDuplicatesFilter = string
        },
        personsDuplicatesFindSet (state: State, persons: Person[] | Email[] | Phone[]): void {
            state.personsDuplicatesFind = persons
        },
        personsDuplicatesPush (state: State, page: Pagination): void {
            if (!state.personsDuplicates || page.current_page === 1) state.personsDuplicates = []
            state.personsDuplicates = window.removeDuplicatesById(state.personsDuplicates, page.data)
            state.personsDuplicatesLastPage = page.last_page
            state.personsDuplicatesNextPage = page.current_page + 1
        },
        personsDuplicatesPaginatingSet (state: State, bool: boolean): void {
            state.personsDuplicatesPaginating = bool
        },
        personsDuplicatesParamsSet (state: State, params: object): void {
            state.personsDuplicatesParams = params
        },
        personsDuplicatesReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        personsDuplicates ({ commit, getters }, params: object): Promise<Pagination> {
            //  Start paginating
            commit('personsDuplicatesPaginatingSet', true)

            //  Assemble the API endpoint
            const url = `${getters.api}/persons/duplicates?${window.toUrlParams(params)}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our pagination result in the store
                commit('personsDuplicatesPush', response.data)

                //  Stop paginating
                commit('personsDuplicatesPaginatingSet', false)

                //  Return our pagination data
                return response.data
            }).catch(() => null)
        },
        personsDuplicatesFind ({ commit, getters }, params: object): Promise<Pagination> {
            //  Assemble the API endpoint
            const url = `${getters.api}/persons/duplicates/find?${window.toUrlParams(params)}`

            //  send the request
            return window.axios.get(url).then(response => {
                //  Set our found duplicates in the store
                commit('personsDuplicatesFindSet', response.data)

                //  Return the pagination data
                return response.data
            }).catch(() => null)
        },
        personsMerge ({ getters }, params: object): Promise<Person> {
            //  Assemble the API endpoint
            const url = `${getters.api}/persons/duplicates/merge`

            //  Send the request
            return window.axios.post(url, params).then(response => {
                //  Return the merged person
                return response.data
            }).catch(() => null)
        },
    },
    getters: {
        personsDuplicates (state: State): Person[] | Email[] | Phone[] {
            return state.personsDuplicates
        },
        personsDuplicatesLastPage (state: State): number {
            return state.personsDuplicatesLastPage
        },
        personsDuplicatesNextPage (state: State): number {
            return state.personsDuplicatesNextPage
        },
        personsDuplicatesPaginating (state: State): boolean {
            return state.personsDuplicatesPaginating
        },
        personsDuplicatesParams (state: State): object {
            return state.personsDuplicatesParams
        },
        personsDuplicatesFilter (state: State): string {
            return state.personsDuplicatesFilter
        },
        personsDuplicatesFind (state: State): Person[] | Email[] | Phone[] {
            return state.personsDuplicatesFind
        }
    }
}